import { cloud, launch, play } from '@dnb/eufemia/icons';

import Tile from '@/components/Tile';
import useAuth from '@/hooks/useAuth';
import useFeatureFlags from '@/hooks/useFeatureFlags';

import ServicePage from '../../components/ServicePage';

export default function ServiceExplorer() {
  const { isInternal } = useAuth();
  const { featureFlags } = useFeatureFlags();
  return (
    <ServicePage title="Service Explorer">
      <Tile description="See all APIs that you can connect to" icon={cloud} linkTo="/explorer/apis" title="Apis" />
      {isInternal && (
        <Tile description="See and connect to events" icon={play} linkTo="/explorer/events" title="Events" />
      )}
      {isInternal && featureFlags.ENABLE_MCP_PAGES && (
        <Tile description="Discover MCP servers" icon={launch} linkTo="/explorer/mcps" title="MCPs" />
      )}
    </ServicePage>
  );
}
